import { DEMO_SAMPLE_GROUP_TOKEN } from 'packages/cost-management/api/mock-cost-data';
import {
  AnalyticsType,
  analyticsTypeURLParamZod,
} from 'packages/cost-management/types';

// 2026-08-04 Used Cursor (Opus 5) for initial design

export const ANALYTICS_BASE_PATH = '/analytics';
export const ANALYTICS_REQUESTS_PATH = `${ANALYTICS_BASE_PATH}/requests`;
export const ANALYTICS_TEAM_PATH = `${ANALYTICS_BASE_PATH}/team`;
export const ANALYTICS_SAMPLE_GROUP_PATH = `${ANALYTICS_BASE_PATH}/sample-group`;

export const analyticsSampleGroupPath = (
  sampleGroupToken: string,
  type: AnalyticsType = analyticsTypeURLParamZod.enum.cost
): string => `${ANALYTICS_SAMPLE_GROUP_PATH}/${sampleGroupToken}?type=${type}`;

/** TODO - Change later
 * Analytics > Pipelines has no pipeline picker yet, so it opens a known sample group. */
export const ANALYTICS_PIPELINES_PATH = analyticsSampleGroupPath(
  DEMO_SAMPLE_GROUP_TOKEN
);

export const ANALYTICS_NAV_SECTIONS: {
  key: string;
  label: string;
  path: string;
  segments: string[];
}[] = [
  {
    key: 'pipelines',
    label: 'Pipelines',
    path: ANALYTICS_PIPELINES_PATH,
    segments: ['sample-group'],
  },
  {
    key: 'requests',
    label: 'Requests',
    path: ANALYTICS_REQUESTS_PATH,
    segments: ['requests'],
  },
  { key: 'team', label: 'Team', path: ANALYTICS_TEAM_PATH, segments: ['team'] },
];

/** The first path segment after `/analytics`, e.g. `sample-group` for `/analytics/sample-group/abc`. */
const analyticsPathSegment = (pathname: string): string | undefined =>
  pathname.slice(ANALYTICS_BASE_PATH.length).split('/').filter(Boolean)[0];

/** Which Analytics nav item (if any) a pathname belongs to, without the caller needing to know the routes. */
export const analyticsNavKeyForPathname = (
  pathname: string
): string | undefined => {
  if (!pathname.startsWith(ANALYTICS_BASE_PATH)) return undefined;
  const segment = analyticsPathSegment(pathname);
  return ANALYTICS_NAV_SECTIONS.find((section) =>
    section.segments.includes(segment ?? '')
  )?.key;
};

/** Where clicking a given Analytics nav key should navigate to. */
export const analyticsNavTargetForKey = (key: string): string | undefined =>
  ANALYTICS_NAV_SECTIONS.find((section) => section.key === key)?.path;
